import { useState, useEffect } from "react";
import ReportTableBox from "../../organisms/ReportTableBox";
import MessageHouseNotPresent from "../../atoms/MessageHouseNotPresent";
import { searchReport } from "./utils";
import { useIntl } from "react-intl";
import ErrorMessageResponse from "../../atoms/MessageErrorResponse";

import Spinner from "react-bootstrap/Spinner";
import styles from "./index.module.scss";

const ReportTemplate = ({ titleReport, trackingSysId }) => {
  const [housesPresent, setHousesPresent] = useState("loading");
  const [quantityItemsPerPage, setQuantityItemsPerPage] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [errorMessage, setMessageError] = useState(null);
  const intl = useIntl();
  titleReport = intl.messages.reportTable[titleReport]

  useEffect(() => {
    searchReport(
      trackingSysId,
      pageNum,
      quantityItemsPerPage,
      setItems,
      setTotalPages,
      setHousesPresent,
      setMessageError
    );
  }, [pageNum, setItems, trackingSysId, quantityItemsPerPage]);
  return (
    <div className={styles.ReportTemplate}>
      {(() => {
        switch (housesPresent) {
          case false:
            return <MessageHouseNotPresent message={intl.messages.reportTable.messageHouseNotPresent + titleReport} />
          case true:
            return (
              <ReportTableBox
                trackingSysId={trackingSysId}
                titleReport={titleReport}
                items={items}
                totalPages={totalPages}
                pageNum={pageNum}
                setPageNum={setPageNum}
                quantityItemsPerPage={quantityItemsPerPage}
                setQuantityItemsPerPage={setQuantityItemsPerPage}
                labelQuantityItemsPerPage={intl.messages.reportTable.labelQuantityItemsPerPage}
                messageDateNotFilled={intl.messages.reportTable.dateNotFilled}
              />
            );
          case null:
            return <ErrorMessageResponse message={errorMessage} />;
          default:
            return <Spinner animation="border" variant="danger" />;
        }
      })()}
    </div>
  );
};

export default ReportTemplate;
